import React, { useState } from 'react';
import { useField } from 'react-final-form';

import useCurrentWpPlatform from '@dashboard/hooks/useCurrentWpPlatform';
import { ExpandLessOutlined, ExpandMoreOutlined } from '@mui/icons-material';
import { Box, Button, Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';

export default function AdvancedOptionsSection() {
  const { data } = useCurrentWpPlatform();
  const [isExpanded, setIsExpanded] = useState(false);
  const { input } = useField<boolean>('configuration.legacyTemplatesEnabled');

  const legacyTemplatesEnabled = data?.Platform.legacyTemplatesEnabled;
  if (!legacyTemplatesEnabled) {
    return null;
  }

  if (!isExpanded) {
    return (
      <Box>
        <Button
          size="small"
          onClick={() => setIsExpanded(true)}
          startIcon={<ExpandMoreOutlined />}
          sx={{ mt: 1, ml: -1 }}
        >
          Advanced settings
        </Button>
      </Box>
    );
  }

  return (
    <Box>
      <Button
        size="small"
        onClick={() => setIsExpanded(false)}
        startIcon={<ExpandLessOutlined />}
        sx={{ mt: 1, ml: -1 }}
      >
        Advanced settings
      </Button>
      <Stack spacing={0} direction="column" justifyContent="space-between" alignItems="flex-start">
        <FormControlLabel
          label={
            <Typography variant="body2" fontWeight="fontWeightMedium">
              Use legacy rendering engine
            </Typography>
          }
          control={
            <Checkbox
              size="small"
              checked={input.value}
              onChange={(ev, checked) => {
                input.onChange(checked);
              }}
            />
          }
        />
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: -0.75, ml: 3.5 }}>
          Adds extra markup to improve support for older versions of Outlook.
        </Typography>
      </Stack>
    </Box>
  );
}
